<template>
  <div class="page">
    <div class="top">
      <div class="title">当前可用积分</div>
      <div class="num-wrap">
        <van-icon
          v-if="bindFlag == '3'"
          class="icon-link m-white"
          name="info"
        />
        <div v-if="bindFlag == '3'" class="m-white t">已冻结</div>
        <div
          class="num"
          v-if="bindFlag == '1' || bindFlag == '3'"
          :class="{ grey: bindFlag == '3' }"
          v-text="pointStat.userPoint"
        ></div>
        <div class="o-info" v-if="bindFlag == '2' || bindFlag == '3'">
          <van-popover
            theme="dark"
            placement="bottom"
            v-model="bindInfoShow"
            trigger="click"
          >
            <div class="u-point-info">
              <div v-if="bindFlag == '1'">
                微信已绑定“图书馆微服务”，积分累计正常
              </div>
              <div v-if="bindFlag == '2'">
                微信未绑定“图书馆微服务”，尚未累计积分
              </div>
              <div v-if="bindFlag == '3'">
                微信已解绑“图书馆微服务”，积分累计停止
              </div>
            </div>
            <template #reference>
              <div class="info">
                <div class="status">
                  <div v-if="bindFlag == '1'">正常</div>
                  <div v-if="bindFlag == '2'">未启用</div>
                  <div v-if="bindFlag == '3'">已冻结</div>
                </div>
                <van-icon
                  v-if="bindFlag == '2'"
                  class="icon-link"
                  name="question"
                />
                <van-icon
                  v-if="bindFlag == '3'"
                  class="icon-link"
                  name="info"
                />
              </div>
            </template>
          </van-popover>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="btn" @click="handleRouter('/integral')">
          <img class="icon" src="../assets/images/icon-mingxi.png" />
          <div class="text">积分明细</div>
        </div>
        <div class="btn" @click="handleRouter('/integralRule')">
          <img class="icon" src="../assets/images/icon-guize.png" />
          <div class="text">积分规则</div>
        </div>
      </div>
    </div>

    <div class="search-wrap">
      <div class="t">
        <div class="date-wrap">
          <!-- 选择时间 -->
          <van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item
              v-model="timeValue"
              :options="timeOption"
              @change="changeTimeVal"
            />
          </van-dropdown-menu>
        </div>
        <div class="text-wrap">
          <div class="text mr">积分收入 {{ pointStat.incomePointValue }}</div>
          <div class="text">积分支出 {{ pointStat.expenditurePointValue }}</div>
        </div>
      </div>
      <!-- 自定义选择时间 -->
      <div v-if="timeShow" class="time">
        <div class="time-list">
          <div @click="startShow = true">{{ start ? start : "开始时间" }}</div>
          <span> ~ </span>
          <div @click="endShow = true">{{ end ? end : "结束时间" }}</div>
        </div>

        <van-button type="info" class="btn" @click="handleSelfPointQuery"
          >查询</van-button
        >
      </div>
      <van-popup v-model="startShow" position="bottom">
        <van-datetime-picker
          v-model="startTime"
          type="date"
          title="开始日期"
          @cancel="startShow = false"
          @confirm="handleStartConfirm"
        />
      </van-popup>
      <van-popup v-model="endShow" position="bottom">
        <van-datetime-picker
          v-model="endTime"
          type="date"
          title="结束日期"
          @cancel="endShow = false"
          @confirm="handleEndConfirm"
        />
      </van-popup>
    </div>
    <div class="report">
      <div class="bar-wrap">
        <div class="title-wrap">
          <img class="icon" src="../assets/images/icon-baobiao.png" />
          <div>积分收支分类</div>
        </div>
        <!-- 柱状图 -->
        <div v-show="pointTotalList.length > 0" class="chart" ref="bar"></div>
        <div class="none none-chart" v-show="pointTotalList.length <= 0">
          暂无数据
        </div>
      </div>
      <div class="event-wrap">
        <div class="title-wrap">
          <img class="icon" src="../assets/images/icon-mingxi.png" />
          <div>积分收支明细</div>
        </div>
        <div class="none" v-if="detailList.length == 0">暂无数据</div>
        <div class="event" v-for="(item, index) in detailList" :key="index">
          <span v-text="item.insertTime"></span>
          <span v-text="item.detailComments"></span>
          <span
            >{{ item.pointValue >= 0 ? "获得" : "扣除" }}积分{{
              Math.abs(item.pointValue)
            }}分</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getPoint,
  getPointDetails,
  getPointDetailsTotal,
  userPointSignGet,
} from "@/api/integral";
import moment from "moment";
import { STATUS_CODE_OK, TOAST_STAY_TIME } from "@/config";
export default {
  name: "IntegralReport",
  data() {
    return {
      bindInfoShow: false, // 绑定状态提示pop是否显示
      bindFlag: "1", // 公众号绑定状态
      pointStat: {},
      time: [],
      timeShow: false,
      start: "", //自定义选择开始时间
      end: "", //自定义选择结束时间
      startTime: new Date(), //开始时间绑定值
      endTime: new Date(), //结束时间绑定值

      detailList: [], //积分明细
      pointTotalList: [], //积分报表
      startShow: false,
      endShow: false,
      timeValue: 0, //快捷选项时间值
      timeOption: [
        {
          text: "最近一年",
          value: 0,
        },
        {
          text: "最近半年",
          value: 1,
        },
        {
          text: "最近三个月",
          value: 2,
        },
        {
          text: "最近一个月",
          value: 3,
        },
        {
          text: "自定义",
          value: 4,
        },
      ],
      ruleId: "", //点击柱状图获取的规则id
    };
  },
  created() {
    this.handleUserPointGet();
  },
  mounted() {
    this.changeTimeVal(0);
  },
  methods: {
    // 用户积分获取
    async handleUserPointGet() {
      const { data } = await userPointSignGet();
      if (data.code === STATUS_CODE_OK) {
        this.bindFlag = data.data.bindFlag;
      }
    },
    handleRouter(path) {
      this.$router.replace(path);
    },
    //选择时间
    changeTimeVal(value) {
      this.timeShow = false;
      this.startShow = false;
      this.endShow = false;
      this.start = "";
      this.end = "";
      let callData = true;
      if (value == 0) {
        this.time = [
          moment().add(-1, "year").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 1) {
        this.time = [
          moment().add(-6, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 2) {
        this.time = [
          moment().add(-3, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 3) {
        this.time = [
          moment().add(-1, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      if (value == 4) {
        this.time = [];
        this.timeShow = true;
        callData = false;
      }
      if (callData) {
        this.handlePoint();
        this.handlePointDetail();
        this.handlePointTotal();
      }
    },
    //选择开始日期
    handleStartConfirm(value) {
      const time = moment(value).format("YYYY-MM-DD");
      if (
        this.end &&
        moment(time, "YYYY-MM-DD").isAfter(moment(this.end, "YYYY-MM-DD"))
      ) {
        this.$notify({
          type: "warning",
          message: "开始日期不能在结束日期之后",
          duration: TOAST_STAY_TIME,
        });
        return;
      } else {
        this.startShow = false;
        this.start = time;
      }
    },
    //选择结束日期
    handleEndConfirm(value) {
      const time = moment(value).format("YYYY-MM-DD");
      if (
        this.start &&
        moment(time, "YYYY-MM-DD").isBefore(moment(this.start, "YYYY-MM-DD"))
      ) {
        this.$notify({
          type: "warning",
          message: "结束日期不能再开始日期之前",
          duration: TOAST_STAY_TIME,
        });
        return;
      } else {
        this.endShow = false;
        this.end = time;
      }
    },

    //自定义事件查询
    handleSelfPointQuery() {
      if (!this.start) {
        this.$notify({
          type: "warning",
          message: "请选择开始日期",
          duration: TOAST_STAY_TIME,
        });
        return;
      }
      if (!this.end) {
        this.$notify({
          type: "warning",
          message: "请选择结束日期",
          duration: TOAST_STAY_TIME,
        });
        return;
      }
      this.time = [this.start, this.end];
      this.handlePoint();
      this.handlePointDetail();
      this.handlePointTotal();
    },
    //获取用户积分
    async handlePoint() {
      const { data } = await getPoint({
        startTime: this.time[0],
        endTime: this.time[1],
      });
      if (data.code === STATUS_CODE_OK) {
        this.pointStat = data.data;
      }
    },
    //获取用户积分明细
    async handlePointDetail() {
      const { data } = await getPointDetails({
        ruleId: this.ruleId,
        startTime: this.time[0],
        endTime: this.time[1],
        pageNo: 1,
        pageSize: 999999,
      });
      if (data.code === STATUS_CODE_OK) {
        this.detailList = data.data.pageInfo;
        this.ruleId = "";
      }
    },
    //获取用户积分报表
    async handlePointTotal() {
      const { data } = await getPointDetailsTotal({
        startTime: this.time[0],
        endTime: this.time[1],
      });
      if (data.code === STATUS_CODE_OK) {
        this.pointTotalList = data.data;
        if (this.pointTotalList.length > 0) {
          this.$refs.bar.style.height =
            120 + this.pointTotalList.length * 32 + "px";
          this.$nextTick(() => {
            this.drawBarChart();
          });
        }
      }
    },

    // 柱状图
    drawBarChart() {
      const that = this;
      if (!that.barChart) {
        that.barChart = that.$echarts.init(that.$refs.bar);
        that.barChart.on("click", (params) => {
          if (params.componentType === "series") {
            this.ruleId = params.data.id;
            this.handlePointDetail();
          }
        });
      }
      let option = {
        grid: {
          show: false,
          left: 115,
          right: 25,
          top: 25,
          bottom: 20,
        },
        barWidth: 15,
        yAxis: {
          data: this.pointTotalList.map((item) => {
            return item.ruleName;
          }),
          axisLabel: {
            color: "#333",
            fontSize: 12,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#333",
            },
          },
        },
        xAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#333",
            },
          },
        },
        series: [
          {
            label: {
              show: true,
              position: "right",
              color: "#333",
              formatter: (param) => {
                if (param.data.ruleType == "1") {
                  return param.value;
                } else {
                  return param.value * -1;
                }
              },
            },
            data: this.pointTotalList.map((item) => {
              return {
                value: Math.abs(item.sumPointValue),
                id: item.ruleId,
                ruleType: item.ruleType,
                itemStyle: {
                  color:
                    item.sumPointValue >= 0
                      ? new that.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                          { offset: 0, color: "#b1d9ff" },
                          { offset: 1, color: "#3770d3" },
                        ])
                      : new that.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                          { offset: 0, color: "#ffc8c8" },
                          { offset: 1, color: "#bd0000" },
                        ]),
                  borderRadius: [0, 20, 20, 0],
                },
              };
            }),
            type: "bar",
          },
        ],
      };
      that.barChart.setOption(option);
    },
  },
};
</script>

<style lang="scss">
.u-point-info {
  font-size: 12px;
  padding: 6px 12px;
  width: 180px;
}
</style>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  .top {
    background-color: #3770d3;
    color: #fff;
    padding: 15px 0;
    .title {
      text-align: center;
      font-size: 16px;
    }
    .num-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3px;
      .m-white {
        visibility: hidden;
        &.icon-link {
          margin: 0 1px 0 10px;
        }
        &.t {
          padding-right: 10px;
        }
      }
      .num {
        color: #fff;
        font-size: 18px;
        &.grey {
          color: #ccc;
        }
      }
      .o-info {
        display: flex;
        align-items: center;
        .info {
          display: flex;
          align-items: center;
          padding: 0 10px;
          cursor: pointer;
          .status {
            color: #ccc;
          }
          .icon-link {
            color: #ccc;
            font-size: 14px;
            margin-left: 2px;
          }
        }
      }
    }
    .btn-wrap {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 20px;
        border: 1px solid #fff;
        margin: 0 20px;
        font-size: 12px;
        cursor: pointer;
        .icon {
          width: 15px;
          height: 15px;
          display: block;
          margin-right: 5px;
        }
      }
    }
  }
  .search-wrap {
    background-color: #fff;
    .t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 10px 0 10px;
      .date-wrap {
        ::v-deep .van-dropdown-menu__bar {
          box-shadow: none;
        }
      }
      .text-wrap {
        color: #999;
        display: flex;
        .mr {
          margin-right: 15px;
        }
      }
    }
    .time {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      padding-bottom: 5px;
      .time-list {
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          width: 120px;
          text-align: center;
        }
      }
      .btn {
        width: 60px;
        height: 20px;
        padding: 15px 10px;
        border-radius: 10px;
      }
    }
  }

  .report {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    .bar-wrap {
      background-color: #fff;
      padding: 10px;
      flex: 1;
      .chart {
        height: 160px;
      }
      .title-wrap {
        display: flex;
        align-items: center;
        padding: 5px 0;
        border-bottom: 1px solid #eee;
        .icon {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 5px;
        }
      }
      .none-chart {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
      }
    }
    .event-wrap {
      background-color: #fff;
      margin-top: 10px;
      padding: 10px 0;
      flex: 1;
      .title-wrap {
        display: flex;
        align-items: center;
        padding: 5px 10px 20px 10px;
        border-bottom: 1px solid #eee;
        .icon {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 5px;
        }
      }
      .event {
        padding: 10px;
        border-bottom: 1px solid #eee;
        &:nth-of-type(even) {
          background-color: #f1f1f3;
        }
      }
    }
  }

  .none {
    text-align: center;
  }
}
</style>
